import { ACTION_TYPES, ROUTE_TYPES_VALUES } from './constants';

const initialState = {
    isInfoVisible: false,
    isInitialized: false,
    restaurant: null,
    showCallWaiterNotification: false,
    waiterCallError: null,
    tableName: null,
    tableNumber: 0,
    routeType: ROUTE_TYPES_VALUES.MENU,
    isInfoRead: false,
    code: null,
    lastBill: null,
    tableSessionType: null,
    isNewMenuPublished: false,
    publishNewMenuError: null
};

export default function restaurantReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.RESTAURANT_INITIALIZED: {
            const {
                routeType,
                restaurant,
                tableName,
                tableNumber,
                tableSessionType,
                code
            } = action.payload;

            return {
                ...state,
                isInitialized: true,
                routeType,
                restaurant,
                tableName,
                code,
                tableNumber,
                tableSessionType
            };
        }
        case ACTION_TYPES.RESTAURANT_CANNOT_BE_INITIALIZED: {
            return {
                ...state,
                isInitialized: true,
                restaurant: initialState.restaurant,
                tableName: null,
                tableNumber: 0,
                tableSessionType: null
            };
        }

        case ACTION_TYPES.SHOW_INFO: {
            return {
                ...state,
                isInfoVisible: true
            };
        }

        case ACTION_TYPES.HIDE_INFO: {
            return {
                ...state,
                isInfoVisible: false
            };
        }

        case ACTION_TYPES.READ_INFO: {
            return {
                ...state,
                isInfoRead: true
            };
        }

        case ACTION_TYPES.CALL_WAITER: {
            return {
                ...state,
                showCallWaiterNotification: false,
                waiterCallError: initialState.waiterCallError
            };
        }

        case ACTION_TYPES.CALL_WAITER_FAILED: {
            return {
                ...state,
                showCallWaiterNotification: false,
                waiterCallError: action.payload || 'notificationAlredyCalled'
            };
        }

        case ACTION_TYPES.CALL_WAITER_SUCCESS: {
            return {
                ...state,
                showCallWaiterNotification: true,
                waiterCallError: initialState.waiterCallError
            };
        }

        case ACTION_TYPES.WAITER_CALLED: {
            return {
                ...state,
                showCallWaiterNotification: false,
                waiterCallError: initialState.waiterCallError
            };
        }

        case ACTION_TYPES.LAST_BILL_FETCHED: {
            return {
                ...state,
                lastBill: action.payload
            };
        }

        case ACTION_TYPES.LAST_BILL_FETCHING_FAILED: {
            return {
                ...state,
                lastBill: initialState.lastBill
            };
        }

        case ACTION_TYPES.NEW_MENU_PUBLISHED: {
            return {
                ...state,
                isNewMenuPublished: true,
                publishNewMenuError: initialState.publishNewMenuError
            };
        }

        case ACTION_TYPES.NEW_MENU_PUBLISH_FAILED: {
            return {
                ...state,
                isNewMenuPublished: initialState.isNewMenuPublished,
                publishNewMenuError: action.payload
            };
        }

        case ACTION_TYPES.CLEAR_PUBLISH_MENU_ERROR: {
            return {
                ...state,
                isNewMenuPublished: initialState.isNewMenuPublished,
                publishNewMenuError: initialState.publishNewMenuError
            };
        }

        default: return state;
    }
}
